// src/utils/date.js
export function parseDateSafe(input) {
  // Accept Date | number | ISO string (YYYY-MM-DD or full ISO)
  if (input instanceof Date) return input;
  if (typeof input === "number") return new Date(input);
  if (typeof input === "string") {
    // If it looks like YYYY-MM-DD, add local midnight explicitly
    if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      const [y, m, d] = input.split("-").map(Number);
      return new Date(y, m - 1, d, 0, 0, 0, 0); // local midnight (no UTC shift)
    }
    return new Date(input);
  }
  return new Date(NaN);
}

export function formatMonthHeader(date, tz = import.meta.env.VITE_DEFAULT_TZ || undefined) {
  const d = parseDateSafe(date);
  return d.toLocaleDateString(undefined, { month: "long", year: "numeric", timeZone: tz });
}

export function formatLongDate(date, tz = import.meta.env.VITE_DEFAULT_TZ || undefined) {
  const d = parseDateSafe(date);
  // Example: Thursday, 9 October 2025
  return d.toLocaleDateString(undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: tz,
  });
}

export function formatShortTime(date, tz = import.meta.env.VITE_DEFAULT_TZ || undefined) {
  const d = parseDateSafe(date);
  return d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", timeZone: tz });
}